import { render, staticRenderFns } from "./KeyReferences.vue?vue&type=template&id=7214eae5"
import script from "./KeyReferences.vue?vue&type=script&lang=js"
export * from "./KeyReferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports